var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"breadcrumb-nav"},[_c('ul',{staticClass:"breadcrumb-list"},_vm._l((_vm.breadcrumbList),function(item,idx){return _c('li',{key:idx},[_c('span',[_vm._v(_vm._s(item.label))]),(idx < _vm.breadcrumbList.length - 1)?_c('span',{staticClass:"sep"},[_vm._v(">>")]):_vm._e()])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }